import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const DiabetesNutritionAndMetabolicDiseasesIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M79.7856 40C79.7856 61.8153 62.1009 79.5 40.2856 79.5C18.4704 79.5 0.785645 61.8153 0.785645 40C0.785645 18.1848 18.4704 0.5 40.2856 0.5C62.1009 0.5 79.7856 18.1848 79.7856 40Z'
      />
      <g clipPath='url(#clip0_414_10783)'>
        <path
          d='M62.4349 28.6892H42.9217C41.9797 28.6892 41.2233 27.8941 41.2874 26.9385C41.3146 26.5312 41.5044 26.1517 41.793 25.8632L44.2423 23.414C45.8326 21.8236 45.8302 19.2437 44.2352 17.6563C43.6017 17.026 42.5615 17.0315 41.9296 17.6635L30.2833 29.937C29.1537 31.1274 27.5847 31.8015 25.9437 31.8015H16.2917C15.736 31.8015 15.2856 32.2519 15.2856 32.8076V45.2722C15.2856 45.8278 15.736 46.2782 16.2917 46.2782H24.9542C26.8222 46.2782 28.5556 47.1829 29.6884 48.6681C30.9486 50.3206 32.9414 51.4223 35.1281 51.4909L45.1486 51.4955V51.3978C43.6306 51.3978 42.3955 50.1628 42.3955 48.6447C42.3955 47.1266 43.6306 45.8917 45.1486 45.8917V45.6964C43.6306 45.6964 42.3955 44.4613 42.3955 42.9433C42.3955 41.4255 43.6304 40.1905 45.148 40.1901V39.9948C43.6304 39.9945 42.3955 38.7595 42.3955 37.2417C42.3955 35.7236 43.6306 34.4886 45.1486 34.4886H52.6575V34.3909H62.435C64.0094 34.3909 65.2857 33.1145 65.2857 31.5401C65.2856 29.9656 64.0093 28.6892 62.4349 28.6892Z'
          fill='#FFB09E'
        />
        <path
          d='M62.4348 32.3211H47.2181C46.075 32.3211 45.1484 33.2477 45.1484 34.3908H62.4348C64.0092 34.3908 65.2855 33.1144 65.2855 31.54C65.2855 31.1749 65.2161 30.826 65.091 30.5051C64.6767 31.5678 63.644 32.3211 62.4348 32.3211Z'
          fill='#F89580'
        />
        <path
          d='M55.5083 42.9432C55.5083 41.369 54.2323 40.0928 52.6581 40.0924C54.2323 40.0921 55.5083 38.8159 55.5083 37.2417C55.5083 35.6672 54.2319 34.3909 52.6575 34.3909H45.1486C43.5742 34.3909 42.2979 35.6672 42.2979 37.2417C42.2979 38.8159 43.5738 40.0921 45.148 40.0924C43.5738 40.0927 42.2979 41.369 42.2979 42.9432C42.2979 44.5176 43.5742 45.794 45.1486 45.794C43.5742 45.794 42.2979 47.0704 42.2979 48.6448C42.2979 50.2192 43.5742 51.4956 45.1486 51.4956H52.6575C54.2319 51.4956 55.5083 50.2192 55.5083 48.6448C55.5083 47.0704 54.2319 45.794 52.6575 45.794C54.2319 45.794 55.5083 44.5176 55.5083 42.9432Z'
          fill='#FFDFCF'
        />
        <path
          d='M41.7928 25.8632L44.2421 23.414C45.8324 21.8236 45.83 19.2437 44.2348 17.6563C43.6013 17.026 42.5612 17.0315 41.9293 17.6635L41.5006 18.1153C42.6852 19.7074 42.5555 21.969 41.1105 23.414L38.6612 25.8632C38.3726 26.1517 38.1829 26.5312 38.1556 26.9385C38.0916 27.8941 38.8479 28.6893 39.7899 28.6893H42.9215C41.9795 28.6893 41.2231 27.8942 41.2872 26.9385C41.3144 26.5311 41.5042 26.1517 41.7928 25.8632Z'
          fill='#F89580'
        />
        <path
          d='M54.4685 35.0398C54.4695 35.0721 54.4709 35.1043 54.4709 35.137C54.4709 36.7114 53.1945 37.9877 51.6201 37.9877H44.1112C43.4235 37.9877 42.7928 37.7442 42.3003 37.3387C42.3517 38.8681 43.6067 40.0923 45.1486 40.0923H52.6575C54.2319 40.0923 55.5083 38.816 55.5083 37.2416C55.5084 36.3548 55.1034 35.5626 54.4685 35.0398Z'
          fill='#FFCEBF'
        />
        <path
          d='M54.4685 40.7415C54.4695 40.7738 54.4709 40.806 54.4709 40.8386C54.4709 42.413 53.1945 43.6894 51.6201 43.6894H44.1112C43.4235 43.6894 42.7928 43.4459 42.3003 43.0404C42.3517 44.5698 43.6067 45.794 45.1486 45.794H52.6575C54.2319 45.794 55.5083 44.5176 55.5083 42.9432C55.5084 42.0564 55.1034 41.2643 54.4685 40.7415Z'
          fill='#FFCEBF'
        />
        <path
          d='M54.4685 46.4429C54.4695 46.4752 54.4709 46.5074 54.4709 46.54C54.4709 48.1145 53.1945 49.3908 51.6201 49.3908H44.1112C43.4235 49.3908 42.7928 49.1473 42.3003 48.7418C42.3517 50.2712 43.6067 51.4954 45.1486 51.4954H52.6575C54.2319 51.4954 55.5083 50.219 55.5083 48.6446C55.5084 47.7579 55.1034 46.9657 54.4685 46.4429Z'
          fill='#FFCEBF'
        />
        <path
          d='M31.9077 39.1433C31.5031 39.1433 31.1753 38.8154 31.1753 38.4109C31.1753 38.0064 31.5031 37.6785 31.9077 37.6785C34.9778 37.6785 37.4756 35.1807 37.4756 32.1106C37.4756 31.7061 37.8034 31.3782 38.208 31.3782C38.6126 31.3782 38.9404 31.7061 38.9404 32.1106C38.9404 35.9884 35.7855 39.1433 31.9077 39.1433Z'
          fill='#F89580'
        />
        <path
          d='M61.8101 37.693L59.7319 40.4871C58.3623 42.3285 59.6766 44.9439 61.9715 44.9439C64.2664 44.9439 65.5807 42.3285 64.2112 40.4871L62.133 37.693C62.0526 37.5848 61.8905 37.5848 61.8101 37.693Z'
          fill='#FD4755'
        />
        <path
          d='M64.2107 40.4871L62.1326 37.693C62.0521 37.5848 61.8901 37.5848 61.8097 37.693L60.9268 38.8801L62.1221 40.4872C63.2664 42.0258 62.5363 44.1036 60.9268 44.7458C61.2436 44.8722 61.5937 44.944 61.9711 44.944C64.266 44.944 65.5803 42.3285 64.2107 40.4871Z'
          fill='#FB2B3A'
        />
        <path
          d='M61.8101 48.6868L59.7319 51.4809C58.3623 53.3223 59.6766 55.9378 61.9715 55.9378C64.2664 55.9378 65.5807 53.3223 64.2112 51.4809L62.133 48.6868C62.0526 48.5787 61.8905 48.5787 61.8101 48.6868Z'
          fill='#FD4755'
        />
        <path
          d='M64.2107 51.4812L62.1326 48.6871C62.0521 48.5789 61.8901 48.5789 61.8097 48.6871L60.9268 49.8742L62.1221 51.4813C63.2664 53.0199 62.5363 55.0978 60.9268 55.7399C61.2436 55.8663 61.5937 55.9382 61.9711 55.9382C64.266 55.9381 65.5803 53.3227 64.2107 51.4812Z'
          fill='#FB2B3A'
        />
        <path
          d='M62.0869 32.2725H61.8555C61.4509 32.2725 61.123 31.9445 61.123 31.54C61.123 31.1355 61.4509 30.8076 61.8555 30.8076H62.0869C62.4915 30.8076 62.8193 31.1355 62.8193 31.54C62.8193 31.9445 62.4915 32.2725 62.0869 32.2725Z'
          fill='#FB2B3A'
        />
        <path
          d='M53.3643 55.4692H44.813V62.3103H53.3643C54.1977 62.3103 54.8733 61.6346 54.8733 60.8012V56.9782C54.8732 56.1448 54.1977 55.4692 53.3643 55.4692Z'
          fill='#D8ECFE'
        />
        <path
          d='M53.3643 55.4692H50.3462C51.1796 55.4692 51.8553 56.1448 51.8553 56.9783V60.8013C51.8553 61.6347 51.1797 62.3103 50.3462 62.3103H53.3643C54.1977 62.3103 54.8733 61.6347 54.8733 60.8013V56.9783C54.8732 56.1448 54.1977 55.4692 53.3643 55.4692Z'
          fill='#C4E2FF'
        />
        <path
          d='M51.1512 58.1575H48.2617V59.6223H51.1512C51.5558 59.6223 51.8836 59.2944 51.8836 58.8899C51.8836 58.4854 51.5557 58.1575 51.1512 58.1575Z'
          fill='#7A6D79'
        />
        <path
          d='M22.0766 56.0227H18.3543C17.5209 56.0227 16.8452 56.6983 16.8452 57.5318V60.2481C16.8452 61.0815 17.5208 61.7572 18.3543 61.7572H22.0767L22.0766 56.0227Z'
          fill='#B9ACAC'
        />
        <path d='M19.7627 56.0227H22.0766V61.7571H19.7627V56.0227Z' fill='#9E9797' />
        <path
          d='M47.8562 57.6323H44.813V60.1475H47.8562C48.1341 60.1475 48.3593 59.9223 48.3593 59.6444V58.1354C48.3593 57.8575 48.1341 57.6323 47.8562 57.6323Z'
          fill='#B9ACAC'
        />
        <path
          d='M47.8562 57.6323H46.4233C46.7012 57.6323 46.9264 57.8575 46.9264 58.1354V59.6444C46.9264 59.9223 46.7012 60.1475 46.4233 60.1475H47.8562C48.134 60.1475 48.3592 59.9223 48.3592 59.6444V58.1354C48.3592 57.8575 48.134 57.6323 47.8562 57.6323Z'
          fill='#9E9797'
        />
        <path
          d='M44.4106 62.8134H22.4791C22.2013 62.8134 21.9761 62.5882 21.9761 62.3104V55.4693C21.9761 55.1915 22.2013 54.9663 22.4791 54.9663H44.4106C44.6885 54.9663 44.9137 55.1915 44.9137 55.4693V62.3104C44.9137 62.5882 44.6885 62.8134 44.4106 62.8134Z'
          fill='#26A6FE'
        />
        <path
          d='M44.4106 54.9663H41.3926C41.6704 54.9663 41.8956 55.1915 41.8956 55.4693V62.3104C41.8956 62.5882 41.6704 62.8134 41.3926 62.8134H44.4106C44.6885 62.8134 44.9137 62.5882 44.9137 62.3104V55.4693C44.9137 55.1915 44.6885 54.9663 44.4106 54.9663Z'
          fill='#0593FC'
        />
        <path
          d='M37.821 57.5315H32.6431L32.5454 57.645V60.1083L32.6431 60.2478H37.821C38.568 60.2478 39.1791 59.6366 39.1791 58.8897C39.1792 58.1427 38.5681 57.5315 37.821 57.5315Z'
          fill='white'
        />
        <path
          d='M29.927 57.5316C29.18 57.5316 28.5688 58.1427 28.5688 58.8897C28.5688 59.6367 29.18 60.2478 29.927 60.2478H32.6433V57.5315H29.927V57.5316Z'
          fill='#FD4755'
        />
        <path
          d='M37.8209 57.5317H36.5239C37.0166 57.7862 37.3561 58.2998 37.3561 58.8898C37.3561 59.4799 37.0166 59.9935 36.5239 60.2479H37.8209C38.5679 60.2479 39.179 59.6367 39.179 58.8898C39.1791 58.143 38.568 57.5317 37.8209 57.5317Z'
          fill='#FAF7F7'
        />
      </g>
      <defs>
        <clipPath id='clip0_414_10783'>
          <rect width='50' height='50' fill='white' transform='translate(15.2856 15)' />
        </clipPath>
      </defs>
    </svg>
  )
);
DiabetesNutritionAndMetabolicDiseasesIcon.displayName = 'DiabetesNutritionAndMetabolicDiseasesIcon';

export default DiabetesNutritionAndMetabolicDiseasesIcon;
